import router from './../router'

export const isRouteName = (routeName) => {
    return router.currentRoute.name === routeName
};

export const addOrUpdateItem = (state, item, key = 'id', node = 'items') => {
    if (_itemExists(state[node], item, key)) {
        // Vue.set(state, node, _listWithUpdatedItem(state[node], item, key))
        state.items = _listWithUpdatedItem(state[node], item, key)
    } else {
        // Vue.set(state, node, [...state[node], item])
        state.items = [...state[node], item]
    }
};

export const removeItem = (state, item, key = 'id', node = 'items') => {
    let keys = key instanceof Array === true ? key: [key]
    let index = _.findIndex(state[node], _.pick(item, keys))

    if (index > -1) {
        state[node].splice(index, 1)
        // Vue.set(state, node, state[node])
        state.items = state[node]
    }
};

export const findItem = (state, value, key = 'id', node = 'items') => {
    return _.find(state[node], existing => existing[key] == value)
};

const _listWithUpdatedItem = (items, item, key) => {
    let keys = key instanceof Array ? key : [key]

    return _.map(items, existing => {
        if (_.isEqual(_.pick(existing, keys), _.pick(item, keys))) {
            return Object.assign(existing, item)
        }
        else{
            return existing
        }
    })
};

const _itemExists = (items, item, key) => {
    let keys = key instanceof Array === true ? key : [key]

    return _.find(items, _.pick(item, keys)) !== undefined
};

/**
 * Returns o1 keys values of which don't much with o2
 * @param o1
 * @param o2
 * @returns {Array}
 */
export const objDifference = (o1, o2) => {
    let result = []

    for (let key in o1) {
        if (o1[key] instanceof Object) {
            var diff = objDifference(o1[key], o2[key] instanceof Object ? o2[key] : {})
            for (var i in diff) {
                result.push(key + '.' + diff[i])
            }
        } else {
            if (o1[key] != o2[key]) result.push(key)
        }
    }

    return result
};

/**
 * Creates a function which updates the url and commits page variables to the store
 *
 * Example: ./modules/pages/admin-messages/actions.js
 *
 * @param pageUrl
 * @param variablesMutation
 * @returns {Function}
 */
export const handlePageVariablesUpdate = (pageUrl, variablesMutation) => {
    return (store, variables) => {
        let constants = store.state.constants,
            copy = Object.assign({}, variables),
            old = Object.assign({}, store.state.variables),
            query = {}, changes

        changes = objDifference(copy, old)

        if (variablesMutation.page && _.without(changes, 'page').length) {
            copy['page'] = 1;
        }

        for (let param in copy) {
            if (copy[param] != constants[param].defaultValue) {
                query[param] = copy[param]
            }
        }
        router.replace({path: pageUrl, query: query})

        store.commit(variablesMutation, copy)

        return changes
    }
}
